import { useFetcher } from '@remix-run/react'
import { motion } from 'framer-motion'
import { useTranslation } from 'react-i18next'
import PlentyBody from '#app/components/typography/plenty-body'
import { Button } from '#app/components/ui/button'
import { Icon } from '#app/components/ui/icon'
import useAmplitudeContext from '#app/hooks/use-amplitude-context'
import { cn } from '#app/utils/misc'
import { StoreSelectorDrawer } from './store-selector-drawer'
import { StoreSelectorSheet } from './store-selector-sheet'
import { type SelectedStoresCookie } from '.'

interface SelectedStoreProps {
	selectedStores: SelectedStoresCookie[]
}

const SelectedStore = ({ selectedStores }: SelectedStoreProps) => {
	let { t } = useTranslation('product_list_page')
	const { trackAmplitudeEvent } = useAmplitudeContext()
	const removeSelectedStoreFetcher = useFetcher()

	const removeSelectedStore = () => {
		trackAmplitudeEvent('remove selected stores')
		removeSelectedStoreFetcher.submit(null, {
			method: 'POST',
			action: '/resources/removeSelectedStores',
		})
	}
	return (
		<motion.div
			className={cn(
				'z-0 hidden flex-col justify-between space-y-1 bg-beige-50 px-4 py-2 md:flex md:flex-row md:space-y-0 md:px-[var(--plenty-padding)]',
			)}
			initial={{ y: -50, opacity: 0 }}
			animate={{ y: 0, opacity: 1 }}
			transition={{
				type: 'spring',
				stiffness: 300,
				damping: 20,
				duration: 0.35,
			}}
		>
			<div className="flex flex-row items-center space-x-2">
				<PlentyBody>
					{t('selected_stores_results', {
						count: selectedStores.length,
						storeName: selectedStores[0].name,
					})}
				</PlentyBody>
				<Button variant="link" onClick={removeSelectedStore}>
					<Icon name="close" size="sm" />
				</Button>
			</div>
			<div className="hidden md:block">
				<StoreSelectorSheet selectedStores={[]} />
			</div>

			{/* Mobile version (visible on mobile, hidden md and up) */}
			<div className="block md:hidden">
				<StoreSelectorDrawer selectedStores={[]} />
			</div>
		</motion.div>
	)
}

export default SelectedStore
